import React from 'react'
import { Link } from 'react-router-dom'

import Slideone from '../../assets/images/main-slider/slider-1.jpg'
import Slidetwo from '../../assets/images/main-slider/slider-2.jpg'
import Slidethree from '../../assets/images/main-slider/slider-3.jpg'
import Slidepizza from '../../assets/images/resource/food/pizza1.jpg'
import Slidepizza2 from '../../assets/images/resource/food/pizza2.jpg'
import Slidepogacha1 from '../../assets/images/resource/food/pogacha1.jpg'
import Slideplato1 from '../../assets/images/resource/food/plato1.jpg'
import Slidemidi1 from '../../assets/images/resource/food/midi1.jpg'
import Slidekalmari1 from '../../assets/images/resource/food/kalmari1.jpg'
import Slideskaridi1 from '../../assets/images/resource/food/skaridi1.jpg';
import Slidepizza3 from '../../assets/images/resource/food/pizza3.jpg';
import Slidedesert1 from '../../assets/images/resource/food/desert1.jpg';


import Slidemuzika from '../../assets/images/resource/random/muzika2.jpg';


import { Swiper, SwiperSlide } from 'swiper/react';
// import bookicon1 from '../../assets/images/resource/book-icon-1.png'
import { Autoplay } from "swiper";


function Banner() {
    return (
        <>

            <Swiper className="banner-section"
                loop={true}
                spaceBetween={50}
                slidesPerView={1}
                navigation={{
                    nextEl: '.swiper-button-prev',
                    prevEl: '.swiper-button-next',
                }}

                autoplay={{
                    delay: 5500,
                    disableOnInteraction: false,
                }}
                modules={[Autoplay]}
            >

                <div className="banner-container">
                    <div className="banner-slider" >
                        <div className="swiper-wrapper">

                            <SwiperSlide>
                                <div className="swiper-slide slide-item">

                                    <div className="image-layer" style={{ backgroundImage: `url(${Slideskaridi1})`, filter: "brightness(75%)" }}></div>

                                    <div className="auto-container">
                                        <div className="content-box">
                                            <div className="content">
                                                <div className="clearfix">
                                                    <div className="inner">
                                                        <div className="subtitle"><span style={{ fontSize: 20, color: "var(--color-one)" }}>гръцки ресторант Родос</span></div>

                                                        <div className="pattern-image">

                                                            <img src={require('../../assets/images/icons/separator.svg').default} alt='mySvgImage' />

                                                        </div>


                                                        <h1><span >тигрови скариди</span></h1>
                                                        <div style={{ color: "var(--color-one)" }} className="text">с маслен сос</div>
                                                        <div className="links-box wow fadeInUp" data-wow-delay="0ms" data-wow-duration="1500ms">
                                                            <div className="link">
                                                                <Link to="/menu" className="theme-btn btn-style-two clearfix">
                                                                    <span className="btn-wrap">
                                                                        <span className="text-one">разгледайте ни менюто</span>
                                                                        <span className="text-two">разгледайте ни менюто</span>
                                                                    </span>
                                                                </Link>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                <div className="swiper-slide slide-item">
                                    <div className="image-layer" style={{ backgroundImage: `url(${Slidedesert1})`, filter: "brightness(75%)" }}></div>
                                    <div className="auto-container">
                                        <div className="content-box">
                                            <div className="content">
                                                <div className="clearfix">
                                                    <div className="inner">
                                                        <div className="subtitle"><span style={{ fontSize: 20, color: "var(--color-one)" }} >гръцки ресторант Ρόδος</span></div>
                                                        <div className="pattern-image">
                                                            <img src={require('../../assets/images/icons/separator.svg').default} alt='mySvgImage' />
                                                        </div>


                                                        <h1><span>καρυδόπιτα</span></h1>
                                                        <div style={{ color: "var(--color-one)" }} className="text">орехова пита със сладолед</div>
                                                        <div className="links-box wow fadeInUp" data-wow-delay="0ms" data-wow-duration="1500ms">
                                                            <div className="link">
                                                                <Link to="/menu" className="theme-btn btn-style-two clearfix">
                                                                    <span className="btn-wrap">
                                                                        <span className="text-one">разгледайте ни менюто</span>
                                                                        <span className="text-two">разгледайте ни менюто</span>
                                                                    </span>
                                                                </Link>
                                                            </div>
                                                        </div>


                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                <div className="swiper-slide slide-item">

                                    <div className="image-layer" style={{ backgroundImage: `url(${Slidekalmari1})`, filter: "brightness(75%)" }}></div>

                                    <div className="auto-container">
                                        <div className="content-box">
                                            <div className="content">
                                                <div className="clearfix">
                                                    <div className="inner">
                                                        <div className="subtitle"><span style={{ fontSize: 20, color: "var(--color-one)" }}>гръцки ресторант Родос</span></div>

                                                        <div className="pattern-image">

                                                            <img src={require('../../assets/images/icons/separator.svg').default} alt='mySvgImage' />

                                                        </div>


                                                        <h1><span >бейби калмари със средиземноморски сос</span></h1>
                                                        <div style={{ color: "var(--color-one)" }} className="text">гръцка кухня с много разнообразни морски дарове</div>
                                                        <div className="links-box wow fadeInUp" data-wow-delay="0ms" data-wow-duration="1500ms">
                                                            <div className="link">
                                                                <Link to="/menu" className="theme-btn btn-style-two clearfix">
                                                                    <span className="btn-wrap">
                                                                        <span className="text-one">разгледайте ни менюто</span>
                                                                        <span className="text-two">разгледайте ни менюто</span>
                                                                    </span>
                                                                </Link>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                <div className="swiper-slide slide-item">

                                    <div className="image-layer" style={{ backgroundImage: `url(${Slidemuzika})`, filter: "brightness(75%)" }}></div>

                                    <div className="auto-container">
                                        <div className="content-box">
                                            <div className="content">
                                                <div className="clearfix">
                                                    <div className="inner">
                                                        <div className="subtitle"><span style={{ fontSize: 20, color: "var(--color-one)" }}>гръцки ресторант Родос</span></div>

                                                        <div className="pattern-image">

                                                            <img src={require('../../assets/images/icons/separator.svg').default} alt='mySvgImage' />

                                                        </div>


                                                        <h1><span >гръцка вечер</span></h1>
                                                        <div style={{ color: "var(--color-one)" }} className="text">с любезното съдействие на Узо "Полмари" и Bouzouki Instrumental Music Stefanos❤️</div>
                                                        <div className="links-box wow fadeInUp" data-wow-delay="0ms" data-wow-duration="1500ms">
                                                            <div className="link">
                                                                <Link to="/menu" className="theme-btn btn-style-two clearfix">
                                                                    <span className="btn-wrap">
                                                                        <span className="text-one">разгледайте ни менюто</span>
                                                                        <span className="text-two">разгледайте ни менюто</span>
                                                                    </span>
                                                                </Link>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                <div className="swiper-slide slide-item">

                                    <div className="image-layer" style={{ backgroundImage: `url(${Slidepizza3})`, filter: "brightness(75%)" }}></div>

                                    <div className="auto-container">
                                        <div className="content-box">
                                            <div className="content">
                                                <div className="clearfix">
                                                    <div className="inner">
                                                        <div className="subtitle"><span style={{ fontSize: 20, color: "var(--color-one)" }}>гръцки ресторант Родос</span></div>

                                                        <div className="pattern-image">

                                                            <img src={require('../../assets/images/icons/separator.svg').default} alt='mySvgImage' />

                                                        </div>


                                                        <h1><span >Пица</span></h1>
                                                        <div style={{ color: "var(--color-one)" }} className="text">и още много други приятни изненади</div>
                                                        <div className="links-box wow fadeInUp" data-wow-delay="0ms" data-wow-duration="1500ms">
                                                            <div className="link">
                                                                <Link to="/menu" className="theme-btn btn-style-two clearfix">
                                                                    <span className="btn-wrap">
                                                                        <span className="text-one">разгледайте ни менюто</span>
                                                                        <span className="text-two">разгледайте ни менюто</span>
                                                                    </span>
                                                                </Link>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                <div className="swiper-slide slide-item">

                                    <div className="image-layer" style={{ backgroundImage: `url(${Slideplato1})`, filter: "brightness(75%)" }}></div>

                                    <div className="auto-container">
                                        <div className="content-box">
                                            <div className="content">
                                                <div className="clearfix">
                                                    <div className="inner">
                                                        <div className="subtitle"><span style={{ fontSize: 20, color: "var(--color-one)" }}>гръцки ресторант Родос</span></div>

                                                        <div className="pattern-image">

                                                            <img src={require('../../assets/images/icons/separator.svg').default} alt='mySvgImage' />

                                                        </div>


                                                        <h1><span >Плато морски дарове</span></h1>
                                                        <div style={{ color: "var(--color-one)" }} className="text">гръцка кухня с много разнообразни морски дарове</div>
                                                        <div className="links-box wow fadeInUp" data-wow-delay="0ms" data-wow-duration="1500ms">
                                                            <div className="link">
                                                                <Link to="/menu" className="theme-btn btn-style-two clearfix">
                                                                    <span className="btn-wrap">
                                                                        <span className="text-one">разгледайте ни менюто</span>
                                                                        <span className="text-two">разгледайте ни менюто</span>
                                                                    </span>
                                                                </Link>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                <div className="swiper-slide slide-item">

                                    <div className="image-layer" style={{ backgroundImage: `url(${Slidemidi1})`, filter: "brightness(75%)" }}></div>

                                    <div className="auto-container">
                                        <div className="content-box">
                                            <div className="content">
                                                <div className="clearfix">
                                                    <div className="inner">
                                                        <div className="subtitle"><span style={{ fontSize: 20, color: "var(--color-one)" }}>гръцки ресторант Родос</span></div>

                                                        <div className="pattern-image">

                                                            <img src={require('../../assets/images/icons/separator.svg').default} alt='mySvgImage' />

                                                        </div>


                                                        <h1><span >миди</span></h1>
                                                        <div style={{ color: "var(--color-one)" }} className="text">гръцка кухня с много разнообразни морски дарове</div>
                                                        <div className="links-box wow fadeInUp" data-wow-delay="0ms" data-wow-duration="1500ms">
                                                            <div className="link">
                                                                <Link to="/menu" className="theme-btn btn-style-two clearfix">
                                                                    <span className="btn-wrap">
                                                                        <span className="text-one">разгледайте ни менюто</span>
                                                                        <span className="text-two">разгледайте ни менюто</span>
                                                                    </span>
                                                                </Link>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                <div className="swiper-slide slide-item">

                                    <div className="image-layer" style={{ backgroundImage: `url(${Slidepizza2})`, filter: "brightness(75%)" }}></div>

                                    <div className="auto-container">
                                        <div className="content-box">
                                            <div className="content">
                                                <div className="clearfix">
                                                    <div className="inner">
                                                        <div className="subtitle"><span style={{ fontSize: 20, color: "var(--color-one)" }}>гръцки ресторант Родос</span></div>

                                                        <div className="pattern-image">

                                                            <img src={require('../../assets/images/icons/separator.svg').default} alt='mySvgImage' />

                                                        </div>


                                                        <h1><span >Пица - Прошуто, Морски език и Дзадзики</span></h1>
                                                        <div style={{ color: "var(--color-one)" }} className="text">традиционна гръцка кухня, морски дарове, пици</div>
                                                        <div className="links-box wow fadeInUp" data-wow-delay="0ms" data-wow-duration="1500ms">
                                                            <div className="link">
                                                                <Link to="/menu" className="theme-btn btn-style-two clearfix">
                                                                    <span className="btn-wrap">
                                                                        <span className="text-one">разгледайте ни менюто</span>
                                                                        <span className="text-two">разгледайте ни менюто</span>
                                                                    </span>
                                                                </Link>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                <div className="swiper-slide slide-item">

                                    <div className="image-layer" style={{ backgroundImage: `url(${Slidepogacha1})`, filter: "brightness(75%)" }}></div>

                                    <div className="auto-container">
                                        <div className="content-box">
                                            <div className="content">
                                                <div className="clearfix">
                                                    <div className="inner">
                                                        <div className="subtitle"><span style={{ fontSize: 20, color: "var(--color-one)" }}>гръцки ресторант Родос</span></div>

                                                        <div className="pattern-image">

                                                            <img src={require('../../assets/images/icons/separator.svg').default} alt='mySvgImage' />

                                                        </div>


                                                        <h1><span >Домашна погача</span></h1>
                                                        <div style={{ color: "var(--color-one)" }} className="text">При нас освен че може да се насладите на прясна морска храна традиционна за остров Родос, бихте могли и да откриете още много други приятни изненади.</div>
                                                        <div className="links-box wow fadeInUp" data-wow-delay="0ms" data-wow-duration="1500ms">
                                                            <div className="link">
                                                                <Link to="/menu" className="theme-btn btn-style-two clearfix">
                                                                    <span className="btn-wrap">
                                                                        <span className="text-one">разгледайте ни менюто</span>
                                                                        <span className="text-two">разгледайте ни менюто</span>
                                                                    </span>
                                                                </Link>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                <div className="swiper-slide slide-item">

                                    <div className="image-layer" style={{ backgroundImage: `url(${Slideone})`, filter: "brightness(75%)" }}></div>

                                    <div className="auto-container">
                                        <div className="content-box">
                                            <div className="content">
                                                <div className="clearfix">
                                                    <div className="inner">
                                                        <div className="subtitle"><span style={{ fontSize: 20, color: "var(--color-one)" }}>гръцки ресторант Родос</span></div>

                                                        <div className="pattern-image">

                                                            <img src={require('../../assets/images/icons/separator.svg').default} alt='mySvgImage' />

                                                        </div>


                                                        <h1><span >Магията на остров Родос</span></h1>
                                                        <div style={{ color: "var(--color-one)" }} className="text">Насладете се на традиционна храна от остров Родос и на нашите пици</div>
                                                        <div className="links-box wow fadeInUp" data-wow-delay="0ms" data-wow-duration="1500ms">
                                                            <div className="link">
                                                                <Link to="/menu" className="theme-btn btn-style-two clearfix">
                                                                    <span className="btn-wrap">
                                                                        <span className="text-one">разгледайте ни менюто</span>
                                                                        <span className="text-two">разгледайте ни менюто</span>
                                                                    </span>
                                                                </Link>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                <div className="swiper-slide slide-item">

                                    <div className="image-layer" style={{ backgroundImage: `url(${Slidepizza})`, filter: "brightness(75%)" }}></div>

                                    <div className="auto-container">
                                        <div className="content-box">
                                            <div className="content">
                                                <div className="clearfix">
                                                    <div className="inner">
                                                        <div className="subtitle"><span style={{ fontSize: 20, color: "var(--color-one)" }}>гръцки ресторант Родос</span></div>

                                                        <div className="pattern-image">

                                                            <img src={require('../../assets/images/icons/separator.svg').default} alt='mySvgImage' />

                                                        </div>


                                                        <h1><span >нашите пици ❤️</span></h1>
                                                        <div style={{ color: "var(--color-one)" }} className="text">Насладете се на традиционна храна от остров Родос и на нашите пици</div>
                                                        <div className="links-box wow fadeInUp" data-wow-delay="0ms" data-wow-duration="1500ms">
                                                            <div className="link">
                                                                <Link to="/menu" className="theme-btn btn-style-two clearfix">
                                                                    <span className="btn-wrap">
                                                                        <span className="text-one">разгледайте ни менюто</span>
                                                                        <span className="text-two">разгледайте ни менюто</span>
                                                                    </span>
                                                                </Link>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </SwiperSlide>

                            <SwiperSlide>
                                <div className="swiper-slide slide-item">
                                    <div className="image-layer" style={{ backgroundImage: `url(${Slidetwo})`, filter: "brightness(75%)" }}></div>
                                    <div className="auto-container">
                                        <div className="content-box">
                                            <div className="content">
                                                <div className="clearfix">
                                                    <div className="inner">
                                                        <div className="subtitle"><span style={{ fontSize: 20, color: "var(--color-one)" }}>гръцки ресторант Ρόδος</span></div>
                                                        <div className="pattern-image">
                                                            <img src={require('../../assets/images/icons/separator.svg').default} alt='mySvgImage' />
                                                        </div>


                                                        <h2><span>магията на остров Родос</span></h2>
                                                        <div style={{ color: "var(--color-one)" }} className="text">Насладете се на традиционна храна от остров Родос и на нашите пици</div>
                                                        <div className="links-box wow fadeInUp" data-wow-delay="0ms" data-wow-duration="1500ms">
                                                            <div className="link">
                                                                <Link to="/menu" className="theme-btn btn-style-two clearfix">
                                                                    <span className="btn-wrap">
                                                                        <span className="text-one">разгледайте ни менюто</span>
                                                                        <span className="text-two">разгледайте ни менюто</span>
                                                                    </span>
                                                                </Link>
                                                            </div>
                                                        </div>


                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </SwiperSlide>


                        </div>

                        <div className="swiper-button-prev"><span className="fal fa-angle-left"></span></div>
                        <div className="swiper-button-next"><span className="fal fa-angle-right"></span></div>


                    </div>
                </div>

                {/* <div className="book-btn">
                    <Link to="#" className="theme-btn">
                        <span className="icon">
                            <img src={bookicon1} alt="" title="" />
                        </span>
                        <span className="txt">book a table</span>
                    </Link>
                </div> */}

            </Swiper>

        </>
    )
}

export default Banner